var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m613.68 624.6-313.68 30.359-82.559 264c-3.2344 10.238-2.3125 21.336 2.5625 30.902 4.875 9.5625 13.312 16.832 23.496 20.23 10.184 3.4023 21.297 2.6641 30.941-2.0547l687.48-332.88c8.8281-4.3086 15.715-11.777 19.285-20.93 3.5742-9.1484 3.5742-19.312 0-28.461-3.5703-9.1523-10.457-16.621-19.285-20.93l-687-333.12c-9.6445-4.7148-20.758-5.4531-30.941-2.0547-10.184 3.4023-18.621 10.668-23.496 20.234-4.875 9.5664-5.7969 20.664-2.5625 30.902l82.559 264 313.08 30.359c8.2148 0.8125 15.48 5.6719 19.371 12.949 3.8906 7.2812 3.8906 16.02 0 23.301-3.8906 7.2812-11.156 12.137-19.371 12.949z",
    fill: "#1e1e1e"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.854c72c09cfbd3488ac3ce6d89901b31.svg";
export { ForwardRef as ReactComponent };